var _path, _path2, _rect;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftAlignment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.3431 3.90544H28.3431C28.6967 3.90544 29.0359 3.76496 29.2859 3.51491C29.536 3.26486 29.6764 2.92572 29.6764 2.5721C29.6764 2.21848 29.536 1.87934 29.2859 1.62929C29.0359 1.37925 28.6967 1.23877 28.3431 1.23877H4.3431C3.98948 1.23877 3.65034 1.37925 3.40029 1.62929C3.15024 1.87934 3.00977 2.21848 3.00977 2.5721C3.00977 2.92572 3.15024 3.26486 3.40029 3.51491C3.65034 3.76496 3.98948 3.90544 4.3431 3.90544Z",
    fill: "#CCA3CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.91455 30.7609H27.772C28.2772 30.7609 28.7616 30.6204 29.1189 30.3704C29.4761 30.1203 29.6768 29.7812 29.6768 29.4276C29.6768 29.0739 29.4761 28.7348 29.1189 28.4848C28.7616 28.2347 28.2772 28.0942 27.772 28.0942H4.91455C4.40937 28.0942 3.92488 28.2347 3.56766 28.4848C3.21045 28.7348 3.00977 29.0739 3.00977 29.4276C3.00977 29.7812 3.21045 30.1203 3.56766 30.3704C3.92488 30.6204 4.40937 30.7609 4.91455 30.7609Z",
    fill: "#CCA3CF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.00977,
    y: 7.90576,
    width: 16.1885,
    height: 16.1885,
    rx: 2,
    fill: "#CCA3CF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftAlignment);
export default __webpack_public_path__ + "static/media/leftAlignment.9786f2d6a21bf28f5ac68ce86c8531d4.svg";
export { ForwardRef as ReactComponent };